/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const CredentialClaimValues: core.serialization.Schema<
    serializers.CredentialClaimValues.Raw,
    Truvity.CredentialClaimValues
> = core.serialization.record(
    core.serialization.string(),
    core.serialization.lazy(() => serializers.CredentialClaimValue),
);

export declare namespace CredentialClaimValues {
    export type Raw = Record<string, serializers.CredentialClaimValue.Raw>;
}
